import React, { useContext, useState } from 'react'
import { SendRounded } from '@material-ui/icons'
import { SentimentSatisfiedAltOutlined } from '@material-ui/icons';
import Picker from 'emoji-picker-react';
import Axios from 'axios'

import { AuthContext } from '../../context/AuthContext';

import './send.css'
import { MessengerContext } from '../../context/MessengerContext';

const Send = ({sendMessage, socket}) => {

  const [isPickerToggled, setIsPickerToggled] = useState(false)
  const [text, setText] = useState("") 
  const [conversation, setConversation] = useContext(MessengerContext)
  
  const API = process.env.REACT_APP_API_URL

  const {user} = useContext(AuthContext)

  const handlePickerToggle = () => {
    setIsPickerToggled((previousState) => !previousState)
  }

  const handleInputChange = (e) => {
    setText(e.target.value)
  }

  const handleEmojiClick = (event, emojiObject) => {
    setText((text) => text + emojiObject.emoji)
  }

  const handleMessageSending = async (e) => {
    e.preventDefault()
    if(text){
      const {data: {message}} = await Axios.post(API + 'messages/create', {
        conversationId: conversation.conversation._id,
        sender: user._id,
        text: text.trim()
      })
      setConversation((oldConversation) => ({
        ...oldConversation,
        messages: [
          ...oldConversation.messages,
          message
        ]
      }))
      sendMessage(message)
      socket.current.emit("sendMessage", {
        userId: user._id,
        receiverId: conversation.communicator._id,
        text: text
      })
      setText("")
    }
  }

  return (
    <div style={{ position: 'relative' }}>
      {isPickerToggled && <div style={{position: 'absolute',   right: '0', bottom: '4.75rem'}}><Picker onEmojiClick={handleEmojiClick} disableSearchBar={true} pickerStyle={{ backgroundColor: 'white' }} /></div>}
      <div className="send">
          <form onSubmit={handleMessageSending} autoComplete="off">
            <div className="sendWrapper">
              <div className="sendMessageBar">
                  <input type="text" name="" id="sendMessageInput" placeholder='Type a message' onChange={handleInputChange} value={text} />
                  <SentimentSatisfiedAltOutlined className='smileyFace' onClick={handlePickerToggle}/>
              </div>
              <div className="sendButtonWrapper">
                  <SendRounded className='sendButton' onClick={handleMessageSending}/>
              </div>
            </div>
          </form>
      </div>
    </div>
  )
}

export default Send